import React, { Component } from 'react'
import { graphql } from 'gatsby'
import he from 'he'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import Seo from "../components/seo"
import Plyr from '../components/plyr'

import Link from '../utils/link'
import TeamProperties from '../components/team-properties'

class TeamTemplate extends Component {

  constructor(props) {
    super(props)
    this.props.data.current.edges = this.props.data.current.edges.filter(el => el.node.propertyData.consultant_ids.indexOf(this.props.data.wpTeam.boxId) !== -1)
    this.props.data.sold.edges = this.props.data.sold.edges.filter(el => el.node.propertyData.consultant_ids.indexOf(this.props.data.wpTeam.boxId) !== -1)
    this.props.data.projects.edges = this.props.data.projects.edges.filter(el => el.node.acf.agent?.length > 0 && el.node.acf.agent.map(agent => agent.boxId).indexOf(this.props.data.wpTeam.boxId) !== -1)

    this.props.data.current.edges.sort((a, b) => new Date(b.node.date) - new Date(a.node.date))
    this.props.data.sold.edges.sort((a, b) => new Date(b.node.date) - new Date(a.node.date))
  }

  scrollDown = () => {
    const { top } = document.querySelector('.team-member__inner').getBoundingClientRect()
    const hh = document.querySelector('header').clientHeight || 0
    window.scrollTo({ left: 0, top: top - hh, behavior: "smooth" });
  }

  _getVideoID(url) {
    if (!url) return null
    let regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    let match = url.match(regExp)
    return match && match.length > 1 && match[1]
  }

  render() {
    
    const team = this.props.data.wpTeam
    const current_properties = this.props.data.current.edges
    const sold_properties = this.props.data.sold.edges 
    const projects = this.props.data.projects.edges

    let mobile = team.acf.mobile ? team.acf.mobile : team.teamData.mobile
    let email = team.acf.email ? team.acf.email : team.teamData.email

    const ytbanner = this._getVideoID(team.acf.video)

    return (
      <>
        <Seo bodyClass='single-team' {...team.seo} />
        <section className='team-member'>

          { ytbanner &&
            <div className='team-member__video'>
              <div className='team-member__video__wrapper'>
                <Plyr
                  type="youtube"
                  videoId={ytbanner}
                  autoplay={true}
                  muted={true}
                  urls={{
                    youtube: {
                      api: `https://noembed.com/embed?url=${0}`
                    }
                  }}
                />
              </div>

            </div>
          }

          <div className='team-member__inner'>


            <div className='team-member__inner__left'>
              <h1>{team.title}</h1>
              <h2>
                {team.acf.jobTitle || team.teamData.position}
                { team.acf.licenseTitle && (<span>{ team.acf.licenseTitle }</span>) }
              </h2>
              <ul>
                { mobile &&
                  <li>
                    <Link to={`tel:${mobile}`}>{ process.env.GATSBY_LOCATION === 'aus' ? parsePhoneNumberFromString(mobile, 'AU').formatNational() : mobile }</Link>
                  </li>
                }
                <li>
                  <Link to={`mailto:${email}`}>{ email }</Link>
                </li>
                { team.acf.instagram && <li><Link to={team.acf.instagram}>Instagram</Link></li> }
                { team.acf.facebook && <li><Link to={team.acf.facebook}>Facebook</Link></li> }
              </ul>
              { team.acf.profileImage && <img src={team.acf.profileImage.localFile.publicURL} alt={team.title} /> }
              <div className='paragraph' dangerouslySetInnerHTML={{ __html: team.acf.content }} />
            </div>
            <div className='team-member__inner__right'>
              <span className='back-button desktop' onClick={() => window.history.go(-1)}>Back to Team</span>
              { team.acf.profileImage && <img src={team.acf.profileImage.localFile.publicURL} alt={team.title} /> }
            </div>
            
          </div>
        </section>
        { (current_properties.length > 0 || sold_properties.length > 0) &&
          <TeamProperties sold={sold_properties} current={current_properties} projects={projects} />
        }
      </>
    )
  }
}


export const teamQuery = graphql`
  query MemberTemplateQuery ($id: String!) {
    wpTeam(id: {eq: $id}) {
      title
      slug
      seo {
        ...WpSeo
      }
      boxId
      teamData {
        first_name
        last_name
        mobile
        email
        position
      }
      acf {
        profileImage {
          localFile { publicURL }
          altText
        }
        bannerImage {
          localFile { publicURL }
          altText
        }
        firstName
        lastName
        email
        mobile
        jobTitle
        licenseTitle
        video
        content
        instagram
        facebook
      }
    }
    projects: allWpBought {
      edges {
        node {
          slug
          title
          date
          acf {
            agent {
              ... on WpTeam {
                boxId
              }
            }
            featuredImage {
              localFile {
                publicURL
              }
            }
            price
            specs {
              bath
              bed
              car
            }
            testimonial
            weblink
          }
        }
      }
    }
    current: allWpProperty(
      filter: {
      propertyData: {
        website_status: { eq: "current" }
      }
    }
    ) {
      edges {
        node {
          ...PropertyCard
        }
      }
    }
    sold: allWpProperty(
      filter: {
        propertyData: {
          website_status: { eq: "sold" }
        }
      }
    ) {
      edges {
        node {
          ...PropertyCard
        }
      }
    }
  }
`

export default TeamTemplate

